import { getEdgeClass } from "../../utils";

const OutlinedButton = ({ title, onClick, classnames, edge }) => {
  return (
    <button
      data-modal-target="default-modal"
      data-modal-toggle="default-modal"
      className={`block bg-[var(--white-shade)] py-[10px] border w-full px-8 max-md:text-sm max-md:px-4 hover-bg-primary-color hover:bg-[var(--primary-dark-color)] text-base  text-[var(--primary-dark-color)] ${getEdgeClass(edge, "rounded-[4px]")} ${classnames}`}
      type="button"
      onClick={onClick}
    >
      {title}
    </button>
  );
};
export default OutlinedButton;
